// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e020ff94","575":"408fe170","744":"dcb9e522","801":"2379882b","981":"b70b5043"}[chunkId] + ".chunk.js";
};